import StudentFail from "@/controllers/student/student-fail.js";
import axios from "axios";

export default {
  extends: StudentFail,
  data() {
    return {
      hasPreRegistration: false,
    };
  },
  mounted() {
    this.checkPreRegistration();
  },
  methods: {
    checkPreRegistration() {
      let request = {
        student_ids: [this.$route.params.id],
      };
      axios.post('/student/checkPassFail', request)
        .then(response => {
          if (response.data.has_pre_reg) {
            this.hasPreRegistration = true;
          } else {
            this.hasPreRegistration = false;
          }
        })
        .catch(error => {
          console.error("Error checking pre-registration:", error);
        });
    }
  }
};
